<template>
  <div id="app" >
    <nav-bar
      :isIos="isiOS"
      v-if="($route.name!=='planForChange')
      &&($route.name!=='planForYear')
      &&($route.name!=='planForPerMonth')
      &&($route.name!=='homePage')
      &&($route.name!=='planForBirth')
      &&($route.name!=='myPosition')"
    />
    <router-view />
  </div>
</template>

<script>
import NavBar from './components/NavBar'
import { bridge } from './apis/bridge'
bridge()
export default {
  name: 'App',
  components: { NavBar },
  data () {
    return {
      isiOS: false,
      isAndroid: false
    }
  },
  methods: {
  },
  created () {
    // this.$i18n.locale = ''
    const u = navigator.userAgent
    // const app = navigator.appVersion
    this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  }
}
</script>
<style>
#app {
  width: 100vw;
  min-height: 100vh;
  background-color: white;
}
.md-toast-text{
  white-space:normal
}
</style>
